module.exports = __webpack_public_path__ + "static/2_1_search-2_NB-60ea518d84894a57a43da27cffd34257.svg";